
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.358 16a6.104 6.104 0 01-2.474-.505 6.334 6.334 0 01-2.03-1.409A6.561 6.561 0 01.49 11.991 6.695 6.695 0 010 9.423c0-.178.055-.326.166-.442a.568.568 0 01.432-.175c.172 0 .31.059.41.175.1.116.151.264.151.442a5.45 5.45 0 001.52 3.816 5.136 5.136 0 001.655 1.152 4.995 4.995 0 002.024.412c.724 0 1.401-.137 2.03-.412a5.136 5.136 0 001.656-1.152 5.435 5.435 0 001.52-3.816 5.403 5.403 0 00-1.52-3.797 5.214 5.214 0 00-1.656-1.152 4.973 4.973 0 00-2.03-.416c-.428 0-.821.028-1.181.085l-.212.038-.096.022 2.158 2.203a.67.67 0 01.123.197.603.603 0 01.043.227c0 .168-.055.31-.166.423a.54.54 0 01-.403.171.529.529 0 01-.418-.17L3.24 4.176a.622.622 0 01-.18-.446c0-.169.06-.317.18-.446L6.206.178A.532.532 0 016.624 0c.163 0 .299.058.407.175a.615.615 0 01.162.434.662.662 0 01-.159.424L5.116 2.981l.154-.03c.36-.06.723-.09 1.088-.09.883 0 1.71.17 2.48.51a6.37 6.37 0 012.027 1.407 6.614 6.614 0 011.858 4.645 6.652 6.652 0 01-1.858 4.663 6.293 6.293 0 01-2.027 1.409 6.122 6.122 0 01-2.48.505z","fill":"#fff"}})])
          )
        }
      }
    